import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
var DEFAULT_BUTTON_VARIANT = "primary";
export var getSlateButtonVariant = function(buttonVariant) {
    if (buttonVariant === undefined) {
        return DEFAULT_BUTTON_VARIANT;
    }
    return buttonVariantToSlateTokenMap[buttonVariant];
};
var _obj;
var buttonVariantToSlateTokenMap = (_obj = {}, _define_property(_obj, IButtonElement.ButtonVariant.PRIMARY, "primary"), _define_property(_obj, IButtonElement.ButtonVariant.SECONDARY, "secondary"), _define_property(_obj, IButtonElement.ButtonVariant.TERTIARY, "tertiary"), _define_property(_obj, IButtonElement.ButtonVariant.BUTTON_VARIANT_UNKNOWN, DEFAULT_BUTTON_VARIANT), _obj);
